(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.darkModeFavicon = {
		attach: function (context) {
      if ($('[rel="icon"]',context).length) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          $('.favicon-light-mode',context).remove();
        }
        else {
          $('.favicon-dark-mode',context).remove();
        }
      }

		}
  };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.layouts = {
		attach: function (context) {
		}
	};

	Drupal.killAnimation = $('.layout-builder-form').length > 0;

	// Drupal.behaviors.fadeUpRows = {
	// 	attach: function (context) {
	// 		if (Drupal.killAnimation) {
	// 			return;
	// 		}
	// 		var controller = new ScrollMagic.Controller();
	// 		var items = [
	// 			'.layout > div > div',
	// 			'.ua-layout--one-col .ua-layout__content > div',
	// 			'.ua-layout--one-col .ua-layout__title',
	// 			'.ua-layout--two-col .ua-layout__content__item',
	// 			'.ua-layout--two-col .ua-layout__title',
	// 			'.ua-layout--three-col .ua-layout__content__item',
	// 			'.ua-layout--three-col .ua-layout__title',
	// 		];
	// 		$(items.join(','), context).css({ opacity: 0, }).each(function() {
	// 			var scene = new ScrollMagic.Scene({
	// 				triggerElement: this,
	// 				duration: 200,
	// 				offset: -200
	// 			}).on('enter', function (cur) {
	// 				var el = cur.currentTarget.triggerElement();
	// 				var $el = $(el);

	// 				if (!$el.hasClass('js-scrolled')) {
	// 					var tween = TweenMax.fromTo(el, 1,
	// 						{ y: 150, opacity: 0, },
	// 						{ y: 0, opacity: 1, ease: Circ.easeInOut, }
	// 					);
	// 				}
	// 				$el.addClass('js-scrolled');
	// 			}).addTo(controller);
	// 		});
	// 	}
	// };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.modalSignup = {
		attach: function (context) {
      $('.toggle-modal-signup',context).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        Drupal.toggleSignupModal();
      });

      $('.modal-signup__inner',context).click(function(e) {
        e.stopPropagation();
      });
      $('.modal-signup',context).click(function(e) {
        Drupal.toggleSignupModal();
      });
		}
  };

  Drupal.toggleSignupModal = function (before, after) {
    before = typeof before === 'function' ? before : function() {};
    after = typeof after === 'function' ? after : function() {};

    $('body').toggleClass('js-modal-signup-open');
    if ($('body').hasClass('js-modal-signup-open')) {
      before();
      $('.modal-signup').hide().fadeIn(Drupal.eta, function () {
        $(this).removeAttr('style');
        after();
      });
    }
    else {
      before();
      $('.modal-signup').show().fadeOut(Drupal.eta, function () {
        $(this).removeAttr('style')

        //For video modal, stop playing video
        $(this).removeClass('js-video');
        $('.c-report-list__footer',this).remove(); //this is the video

        after();
      });
    }
  };
})(jQuery, drupalSettings, Drupal);

(function ($, drupalSettings, Drupal) {
	Drupal.behaviors.regionMenu = {
		attach: function (context) {
      $('#menu__trigger',context).on('click mouseover',function(e) {
        var ww = $(window).width();
        e.preventDefault();

        if (ww <= Drupal.breakpoint.medium && e.type == 'mouseover') return; //kill mobile click state

        $('body').toggleClass('js-ham-open');

        if (ww <= Drupal.breakpoint.medium) {
          $('body,html').animate({
            scrollTop: 0,
          },Drupal.eta);
        }
        if (ww > Drupal.breakpoint.medium) {
          Drupal.menuHoverTimer = setTimeout(Drupal.menuHoverFunction, Drupal.menuEta);
        }
      });
      $('#menu').hover(null,function() {
        if ($(window).width() > Drupal.breakpoint.medium) {
          // clearTimeout(Drupal.menuHoverTimer);
          // Drupal.menuHoverTimer = setTimeout(Drupal.menuHoverFunction, Drupal.menuEta);
          $('body').removeClass('js-ham-open');
        }
      })
		}
  };

  Drupal.menuEta = 5000;
  Drupal.menuHoverTimer = false;
  Drupal.menuHoverFunction = function() {
    if (!$('#menu').is(':hover')) {
      $('body').removeClass('js-ham-open');
    }
    else {
      Drupal.menuHoverTimer = setTimeout(Drupal.menuHoverFunction, Drupal.menuEta);
    }
  }
})(jQuery, drupalSettings, Drupal);
